module.exports = "<div class=\"sql-preview-container\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"preview-body\">\n                {{query}}\n            </div>\n            <div>\n                <button class=\"lfwms-btn-default btn-copy\" (click)=\"copy()\">{{getLabel('btn_copy')}}</button>\n            </div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/sql-preview-popup/sql-preview-popup.component.html
// module id = ../../../../../src/app/shared/lookup/sql-preview-popup/sql-preview-popup.component.html
// module chunks = main